import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IStatePopupComponentProps, StatePopupComponent} from "../../components/state-popup/state-popup.component";
import React from "react";
import {StatePopupWithDropdownComponent} from "../../components/state-popup/state-popup-with-dropdown.component";
import {CGP_STATE_POPUP_LOCAL_STORAGE_KEY} from "./state-popup-strategies-consts";

export interface StatePopupStrategy {
    shouldDisplayStatePopup(forceDisplay?: boolean): boolean;
    onStateConfirmation(stateID?: string): void;
    onOtherStateClick(): void;
    getComponent(): React.ComponentType<IStatePopupComponentProps>;
    getPopupTitle(): string;
}

export class RegularStatePopupStrategy implements StatePopupStrategy {
    private _popupDisplayedLocalStorageKey = CGP_STATE_POPUP_LOCAL_STORAGE_KEY;

    constructor(private services: IServiceFactoryExtended) {
    }

    onOtherStateClick(): void {
        this.services.analytics.sendAnalytics('Client_Message', 'Confirm_Location_Click', 'OUTSIDE_ONTARIO_LINK');
        this.services.location.push(this.services.sdk.getWrongLocationDetectionPath());
    }

    onStateConfirmation(stateID?: string): void {
        this.services.analytics.sendAnalytics('Client_Message', 'Confirm_Location_Click', 'APPROVE');
        this.services.localStorage.setItem(this._popupDisplayedLocalStorageKey, true);
    }

    shouldDisplayStatePopup(forceDisplay?: boolean): boolean {
       return forceDisplay || Boolean(!this.services.localStorage.getItem(this._popupDisplayedLocalStorageKey));
    }

    getComponent(): React.ComponentType<IStatePopupComponentProps> {
        return StatePopupComponent;
    }

    getPopupTitle(): string {
        return this.services.translation.translate("STATE_POPUP_TITLE");
    }
}

export class OneSiteStatePopupStrategy implements StatePopupStrategy {
    constructor(private services: IServiceFactoryExtended, private _shouldShowLoginFormSessionStorageKey: string) {
    }

    onOtherStateClick(): void {
        this.services.analytics.sendAnalytics('Client_Message', 'Confirm_Location_Click', 'OTHER_STATE_CLICK');
        this.services.location.redirect(this.services.sdk.getWrongLocationDetectionPath());
    }

    onStateConfirmation(stateID?: string): void {
        //Product will probably want different reporting for one site one app flow
        this.services.analytics.sendAnalytics('Client_Message', 'Confirm_Location_Click', 'APPROVE');
        if (stateID) {
            this.services.stateOfResidenceIdentifier.saveStateInCookie(stateID);
            this.services.sessionStorage.setItem(this._shouldShowLoginFormSessionStorageKey, true);
            this.services.window.reload();
        }
    }

    shouldDisplayStatePopup(forceDisplay?: boolean): boolean {
        return forceDisplay || !Boolean(this.services.stateOfResidenceIdentifier.getStateFromCookie());
    }

    getComponent(): React.ComponentType<IStatePopupComponentProps> {
        return StatePopupWithDropdownComponent;
    }

    getPopupTitle(): string {
       //Product will probably want a different title for the one site flow popup.
       return this.services.translation.translate("STATE_POPUP_TITLE");
    }
}